import OutsideClickHandler from 'react-outside-click-handler';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

const UrlSetting = ({ label, value, onChange, placeholder }) => {
  const LINK_TYPES = {
    web: { title: i18n.t('link_web'), value: 'https://', icon: 'fa fa-globe' },
    email: { title: i18n.t('link_mailto'), value: 'mailto:', icon: 'fa fa-envelope' },
    tel: { title: i18n.t('link_tel'), value: 'tel:', icon: 'fa fa-phone' },
    unsubscribe: { title: i18n.t('link_unsubscribe'), value: '[%unsubscribe_link%]' },
    view_link: { title: i18n.t('link_view'), value: '[%view_link%]' }
  };
  const detectType = (value) => {
    if(/^mailto:/i.test(value)) return 'email';
    if(/^tel:/i.test(value)) return 'tel';
    if(/unsubscribe_link/i.test(value)) return 'unsubscribe';
    if(/view_link/i.test(value)) return 'view_link';
    return 'web';
  };

  const [opened, setOpened] = useState(false);
  const [type, setType] = useState(detectType(value));
  const controlLabel = label || i18n.t('link');
  const dropdownWrapperClasses = classNames(
    'fantastic-url-input__types',
    { 'open': opened }
  );

  useEffect(() => {
    setType(detectType(value));
  }, [value]);

  const select = (key) => {
    return () => {
      const newValue = LINK_TYPES[key].value;
      onChange(newValue);
      setType(key);
      setOpened(false);
    }
  };

  const renderOption = (key) => {
    return (
      <li onClick={select(key)} key={key}>
        <a>{LINK_TYPES[key].title} <small>{LINK_TYPES[key].value}</small></a>
      </li>
    );
  };

  const handleChange = (e) => {
    let value = e.target.value;
    if(value.length > 0){
      value = value.replaceAll(/'|`|"/g, '')
    }
    onChange(value)
  }

  const selectedTypeTitle = LINK_TYPES[type].icon ? <i className={LINK_TYPES[type].icon}></i> : LINK_TYPES[type].title;
  return (
    <div className="form-group">
      <label>{controlLabel}</label>
      <div>
        <div className="input-group">
          <span className="input-group-addon fantastic-input-group-addon" onClick={() => setOpened(true)}>
            {selectedTypeTitle} <i className="fa fa-caret-down"></i>
          </span>
          <OutsideClickHandler onOutsideClick={() => setOpened(false)}>
            <div className={dropdownWrapperClasses}>
              <ul className="dropdown-menu">
                <li className="dropdown-header">{ i18n.t('links_regular') }</li>
                {['web', 'email', 'tel'].map(e => renderOption(e))}
                <li className="dropdown-header">{ i18n.t('links_special') }</li>
                <li onClick={select('unsubscribe')}><a>{ i18n.t('link_unsubscribe') }</a></li>
                <li onClick={select('view_link')}><a>{ i18n.t('link_browser_view') }</a></li>
              </ul>
            </div>
          </OutsideClickHandler>
          <input
            value={value}
            type="text"
            onChange={handleChange}
            className="form-control fantastic-form-control"
            placeholder={LINK_TYPES[type].value}
          />
        </div>
      </div>
    </div>
  );
};

export default UrlSetting;
